import { render } from "./AcercaDe.vue?vue&type=template&id=58036a86&scoped=true"
import script from "./AcercaDe.vue?vue&type=script&lang=js"
export * from "./AcercaDe.vue?vue&type=script&lang=js"

import "./AcercaDe.vue?vue&type=style&index=0&id=58036a86&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58036a86"]])

export default __exports__